import axios from 'axios'
import { ref, watch } from 'vue'

export const stateOptions = [
  { key: '', name: 'Selecione' },
  { key: 'Acre', name: 'Acre' },
  { key: 'Alagoas', name: 'Alagoas' },
  { key: 'Amapá', name: 'Amapá' },
  { key: 'Amazonas', name: 'Amazonas' },
  { key: 'Bahia', name: 'Bahia' },
  { key: 'Ceará', name: 'Ceará' },
  { key: 'Distrito Federal', name: 'Distrito Federal' },
  { key: 'Espírito Santo', name: 'Espírito Santo' },
  { key: 'Goiás', name: 'Goiás' },
  { key: 'Maranhão', name: 'Maranhão' },
  { key: 'Mato Grosso', name: 'Mato Grosso' },
  { key: 'Mato Grosso do Sul', name: 'Mato Grosso do Sul' },
  { key: 'Minas Gerais', name: 'Minas Gerais' },
  { key: 'Pará', name: 'Pará' },
  { key: 'Paraíba', name: 'Paraíba' },
  { key: 'Paraná', name: 'Paraná' },
  { key: 'Pernambuco', name: 'Pernambuco' },
  { key: 'Piauí', name: 'Piauí' },
  { key: 'Rio de Janeiro', name: 'Rio de Janeiro' },
  { key: 'Rio Grande do Norte', name: 'Rio Grande do Norte' },
  { key: 'Rio Grande do Sul', name: 'Rio Grande do Sul' },
  { key: 'Rondônia', name: 'Rondônia' },
  { key: 'Roraima', name: 'Roraima' },
  { key: 'Santa Catarina', name: 'Santa Catarina' },
  { key: 'São Paulo', name: 'São Paulo' },
  { key: 'Sergipe', name: 'Sergipe' },
  { key: 'Tocantins', name: 'Tocantins' }
]
// prettier-ignore
export const stateNameToUf = {
  'Acre': 'AC',
  'Alagoas': 'AL',
  'Amapá': 'AP',
  'Amazonas': 'AM',
  'Bahia': 'BA',
  'Ceará': 'CE',
  'Distrito Federal': 'DF',
  'Espírito Santo': 'ES',
  'Goiás': 'GO',
  'Maranhão': 'MA',
  'Mato Grosso': 'MT',
  'Mato Grosso do Sul': 'MS',
  'Minas Gerais': 'MG',
  'Pará': 'PA',
  'Paraíba': 'PB',
  'Paraná': 'PR',
  'Pernambuco': 'PE',
  'Piauí': 'PI',
  'Rio de Janeiro': 'RJ',
  'Rio Grande do Norte': 'RN',
  'Rio Grande do Sul': 'RS',
  'Rondônia': 'RO',
  'Roraima': 'RR',
  'Santa Catarina': 'SC',
  'São Paulo': 'SP',
  'Sergipe': 'SE',
  'Tocantins': 'TO'
}

export const useCityOptions = (stateValueRef) => {
  const cityOptions = ref([{ key: '', name: 'Selecione' }])

  watch(
    stateValueRef,
    async (stateName) => {
      cityOptions.value = [{ key: '', name: 'Carregando...' }]

      const uf = stateNameToUf[stateName]
      if (!uf) {
        cityOptions.value = [{ key: '', name: 'Selecione o estado' }]
        return
      }

      try {
        const { data } = await axios.get(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
        )
        cityOptions.value = [
          { key: '', name: 'Selecione' },
          ...data.map((c) => ({ key: c.nome, name: c.nome }))
        ]
      } catch (e) {
        cityOptions.value = null
        console.error('Erro ao buscar cidades do IBGE:', e)
      }
    },
    { immediate: true }
  )

  return cityOptions
}
